import injector from 'vue-inject'

let _gRecaptchaResponse = null;

injector.constant('recaptcha', {
    sitekey: RECAPTCHA_KEY,
    SetRecaptchaResponse(key) {
        _gRecaptchaResponse = key;
    },
    GetRecaptchaResponse() {
        return _gRecaptchaResponse;
    }
});



// WEBPACK FOOTER //
// ./src/services/recaptcha.js